import { useRecoilState } from "recoil";
import {
  JoinPolicyModalAtom,
  PasswordInitModalAtom,
  ResumeSubscriptionModalAtom,
} from "src/atoms";

export const useModal = () => {
  const [joinPolicyModalState, setJoinPolicyModalState] =
    useRecoilState(JoinPolicyModalAtom);
  const [isOpenPasswordInitModal, setPasswordInitModal] = useRecoilState(
    PasswordInitModalAtom
  );
  // 구독 재개하기 모달
  const [isResumeSubscription, setResumeSubscription] = useRecoilState(
    ResumeSubscriptionModalAtom
  );
  const openTermsService = () => {
    setJoinPolicyModalState((prev) => ({
      ...prev,
      showPolicy: true,
      tabTarget: "tab1",
    }));
  };
  const openPrivacyPolicy = (version?: "2026" | "2014") => {
    setJoinPolicyModalState((prev) => ({
      ...prev,
      showPolicy: true,
      tabTarget: "tab2",
      privacyPolicyVersion: version,
    }));
  };

  const openPaidTermsService = () => {
    setJoinPolicyModalState((prev) => ({
      ...prev,
      showPolicy: true,
      tabTarget: "tab3",
    }));
  };
  const openInformationAgree = () => {
    setJoinPolicyModalState((prev) => ({
      ...prev,
      showPolicy: true,
      tabTarget: "tab4",
    }));
  };
  const hideModal = () => {
    setJoinPolicyModalState((prev) => ({ ...prev, showPolicy: false }));
  };
  return {
    joinPolicyModalState,
    setJoinPolicyModalState,
    isOpenPasswordInitModal,
    setPasswordInitModal,
    openTermsService, // 이용약관
    openPrivacyPolicy, // 개인정보 처리방침
    openPaidTermsService, // 유료 이용약관
    openInformationAgree, // 개인정보 수집 및 이용 동의
    // 구독 재개하기
    isResumeSubscription,
    setResumeSubscription,
    hideModal,
  };
};
